import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { Debounce } from 'lodash-decorators'

import RichTextViewer from '@/_components/richText/viewer/viewer.vue'
import AddButton from '@/_components/button/add/add.vue'
import Languages from '@/views/Language/components/languages/languages.vue'
import String from '@/views/Language/components/string/string.vue'
import StringGroupInfo from '@/views/Language/components/stringGroupInfo/stringGroupInfo.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'

@Component({
    components: { RichTextViewer, AddButton, Languages, String, StringGroupInfo },
})
export default class StringGroup extends Mixins<MixinInterface>() {
    dialog = true
    loading = false
    stringGroup: null | StringGroupModel = null

    filterByMissingTranslations = false

    get activeLanguages() {
        return this.$store.getters.activeLanguages
    }

    get token() {
        return this.$route.params.token
    }

    get stringsFiltered() {
        const filteredBySearchTerm = this.searchTerm
            ? this.stringGroup?.strings.filter((string) => {
                  return string.name
                      .toString()
                      ?.toLowerCase()
                      .includes(this.searchTerm.toString().toLowerCase())
              })
            : this.stringGroup?.strings

        const filteredByMissingTranslations = this.filterByMissingTranslations
            ? filteredBySearchTerm?.filter(
                  (string) =>
                      string.missingTranslations.length > 0 &&
                      string.missingTranslations.findIndex((lang) =>
                          this.activeLanguages.includes(lang)
                      ) > -1
              )
            : filteredBySearchTerm
        return filteredByMissingTranslations
    }

    get countMissingTranslations() {
        const missingTranslations = this.stringGroup?.strings?.filter(
            (string) =>
                string.missingTranslations.length > 0 &&
                string.missingTranslations.findIndex((lang) =>
                    this.activeLanguages.includes(lang)
                ) > -1
        ).length

        if (missingTranslations == 0) {
            this.filterByMissingTranslations = false
        }
        return missingTranslations
    }

    get stringGroupId() {
        return this.$route.params.stringGroupId
    }

    get searchTerm() {
        return this.$store.getters.stringSearchTerm
    }

    @Debounce(200)
    set searchTerm(str: string) {
        this.$store.commit('stringSearchTerm', str)
    }

    created() {
        this.$store.commit('stringSearchTerm', '')
    }

    async mounted() {
        await this.reload()
    }

    reloading = false
    async reload() {
        this.reloading = true
        this.stringGroup = await StringGroupModel.get(this.stringGroupId, this.token)
        this.reloading = false
    }

    async initPostString() {
        if (this.stringGroup) {
            await this.stringGroup.initPostString(null, this.stringGroup.strings, this.stringGroup)
            this.stringGroup = await StringGroupModel.get(this.stringGroupId)
        }
    }
}
